'use client'

import { ChatAvatar } from '../playground-avatar/ChatAvatar'
import { AvatarAssets } from '../playground-avatar/components/AnimatedSpineCharacter'

import { StringMessage } from '@/ug-core/types';

interface Props {
  componentId: string
  personaId?: string
  imageFrame?: string
  avatarAsset: AvatarAssets
  contextValues?: Record<string, string | number | boolean>
  onStringMessage?: (message: StringMessage) => void;
}

export default function Demo({ 
  componentId,
  personaId,
  imageFrame,
  avatarAsset,
  contextValues,
  onStringMessage,
}: Props) {

  return (
    <div className="bg-[#f6f8f4]">
      <main>
      <div>
        <ChatAvatar
            componentId={componentId}
            personaId={personaId}
            avatarAssets={avatarAsset}
            isEnabledSubtitles={false}
            imageFrame={imageFrame}
            contextValues={contextValues}
            onStringMessage={onStringMessage}
          />
        </div>
      </main>
    </div>
  )
}
